(function ($) {
  // Document Ready
  $(document).ready(function () {
    console.log("theme.js initiated");

    // Add nav height calculation
    var navheight = $("#main-nav").outerHeight(true);
    // document.documentElement.style.setProperty("--navHeight", navheight + "px");

    // Combine with existing window events
    var lastScrollTop = 0; // Variable to store the last scroll position
    const $mainNav = $("#main-nav"); // Cache the main navigation element

    // Apply/clear contrast class on the nav based on first section background
    function updateNavContrast() {
      const $firstSection = $("#MainContent").find("section").first();
      if (!$firstSection.length || !$mainNav.length) return;

      const needsContrast = $firstSection.hasClass("bg--light-purple") || $firstSection.hasClass("bg--purple");

      $mainNav.toggleClass("contrast", needsContrast);
    }

    // Initial check on load
    updateNavContrast();

    $(window)
      .off("scroll resize")
      .on("scroll resize", function (event) {
        // Handle scroll events
        var scrolledFromTop = $(window).scrollTop();
        if (scrolledFromTop > 20) {
          $("body").addClass("scrolled");
        } else {
          $("body").removeClass("scrolled");
        }

        // Detect scroll direction
        if (scrolledFromTop > 60) {
          if (scrolledFromTop > lastScrollTop) {
            // Scrolling Down
            $("body").addClass("scrolling-down").removeClass("scrolling-up");
            $mainNav.attr({
              "aria-hidden": "true",
              inert: "true",
            });
          } else if (scrolledFromTop < lastScrollTop) {
            // Scrolling Up
            $("body").addClass("scrolling-up").removeClass("scrolling-down");
            $mainNav.attr("aria-hidden", "false").removeAttr("inert");
          }
          lastScrollTop = scrolledFromTop <= 0 ? 0 : scrolledFromTop; // For Mobile or negative scrolling
        } else {
          // Near the top of the page
          $("body").removeClass("scrolling-down scrolling-up");
          $mainNav.attr("aria-hidden", "false").removeAttr("inert");
        }

        // Re-evaluate on resize (in case first section/layout changes)
        if (event.type === "resize") {
          updateNavContrast();
        }
      });

    // Menu Button Click Events
    // –> need to use the .off here to remove event handlers that were previously attached to elements
    // –> then we re-attach them
    $("#menu-btn")
      .off("click")
      .on("click", function () {
        const isExpanded = $("body").hasClass("menu-open");
        const navMenu = $("#navmenu");

        if (isExpanded) {
          // Close menu
          $("body").removeClass("menu-open");
          $("#menu-btn").attr("aria-expanded", "false");
          navMenu.prop("hidden", true);
          $("#menu-btn").find(".menu-btn-text").text("Menu");
        } else {
          // Open menu
          $("body").addClass("menu-open");
          $("#menu-btn").attr("aria-expanded", "true");
          navMenu.prop("hidden", false);
          $("#menu-btn").find(".menu-btn-text").text("Exit");
        }
      });

    /*****************************************************************
      SBS Content Section - Inline Video Controls
    *****************************************************************/
    function stopAllSbsVideos() {
      $(".sbs-content-section .sbs-video").each(function () {
        this.pause();
        this.currentTime = 0;
        this.load();
        $(this).closest(".image-wrap").find(".play-button").removeClass("playing");
      });
    }

    // Play button within sbs-content-section
    $(document).on("click", ".sbs-content-section .play-button", function (e) {
      e.preventDefault();
      e.stopPropagation();

      var $button = $(this);
      var $container = $button.closest(".image-wrap");
      var videoEl = $container.find(".sbs-video")[0];

      if (!videoEl) return;

      if (videoEl.paused) {
        stopAllSbsVideos();
        videoEl
          .play()
          .then(function () {
            $button.addClass("playing");
          })
          .catch(function (error) {
            console.log("Video play failed:", error);
          });
      } else {
        videoEl.pause();
        videoEl.currentTime = 0;
        videoEl.load();
        $button.removeClass("playing");
      }
    });

    // Clicking the video toggles play/pause
    $(document).on("click", ".sbs-content-section .sbs-video", function () {
      var videoEl = this;
      var $button = $(this).closest(".image-wrap").find(".play-button");

      if (videoEl.paused) {
        stopAllSbsVideos();
        videoEl
          .play()
          .then(function () {
            $button.addClass("playing");
          })
          .catch(function (error) {
            console.log("Video play failed:", error);
          });
      } else {
        videoEl.pause();
        videoEl.currentTime = 0;
        videoEl.load();
        $button.removeClass("playing");
      }
    });

    // Reset button state when video ends
    $(document).on("ended", ".sbs-content-section .sbs-video", function () {
      var $button = $(this).closest(".image-wrap").find(".play-button");
      $button.removeClass("playing");
      this.currentTime = 0;
      this.load();
    });

    /*****************************************************************
      Call in GSAP Animations - Modified to work better with parallax
    ******************************************************************/

    gsap.registerPlugin(ScrollTrigger);

    // Delay fade-in-up animations slightly to let parallax setup first

    gsap.utils.toArray(".fade-in-up").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 88%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          pin: false,
          onComplete: () => {
            // Refresh ScrollTrigger after animation completes
            ScrollTrigger.refresh();
          },
        },
      });
    });

    gsap.utils.toArray(".fade-in").forEach((el) => {
      gsap.from(el, {
        scrollTrigger: {
          start: "top 88%",
          end: "bottom top",
          trigger: el,
          toggleClass: "show",
          once: true,
          pin: false,
          onComplete: () => {
            // Refresh ScrollTrigger after animation completes
            ScrollTrigger.refresh();
          },
        },
      });
    });

    /*****************************************************************
      Marquee Image Section - Desktop Carousel
    ******************************************************************/
    if ($(".marquee-image-section .marquee-desktop-carousel").length) {
      console.log("marquee desktop carousel");

      // Initialize/destroy desktop carousel based on viewport
      function initializeMarqueeDesktopCarousels() {
        var isDesktop = window.matchMedia("only screen and (min-width: 768px)").matches;

        $(".marquee-image-section .marquee-desktop-carousel").each(function () {
          var $carousel = $(this);

          if (isDesktop && !$carousel.hasClass("owl-carousel-initialized")) {
            $carousel.addClass("owl-carousel-initialized").owlCarousel({
              items: 3,
              loop: true,
              autoplay: 300,
              autoplayTimeout: 2000,
              autoplayHoverPause: false,
              autoWidth: true,
              margin: 16, // 1rem gap between items
              stagePadding: 60, // Show partial visibility of 4th image
              dots: false,
              nav: false,
              center: false,
              responsive: {
                768: {
                  items: 3,
                  stagePadding: 60,
                  margin: 16,
                },
                992: {
                  items: 3,
                  stagePadding: 80,
                  margin: 16,
                },
              },
            });

            // Reset autoplay on user interaction
            $carousel.on("changed.owl.carousel", function (event) {
              $(this).trigger("stop.owl.autoplay");
              $(this).trigger("play.owl.autoplay");
            });
          } else if (!isDesktop && $carousel.hasClass("owl-carousel-initialized")) {
            // Destroy carousel on mobile
            $carousel.trigger("destroy.owl.carousel").removeClass("owl-carousel-initialized");
          }
        });
      }

      // Initialize on load
      initializeMarqueeDesktopCarousels();

      // Re-initialize on window resize
      $(window).on("load resize", function () {
        setTimeout(initializeMarqueeDesktopCarousels, 100);
      });
    }

    /*****************************************************************
      Marquee Image Section - Mobile Carousel
    ******************************************************************/
    if ($(".marquee-carousel.owl-carousel").length) {
      $(".marquee-carousel.owl-carousel").owlCarousel({
        loop: true,
        autoplay: true,
        margin: 10,
        autoplayTimeout: 5000,
        autoplayHoverPause: true,
        items: 1,
        stagePadding: 50,
        dots: false,
        nav: false,
      });

      $(".marquee-carousel.owl-carousel").on("changed.owl.carousel", function (event) {
        $(this).trigger("stop.owl.autoplay"); // resets the autoplay when
        $(this).trigger("play.owl.autoplay"); // user performs any actions
      });
    }

    /***************************************************
      Scroll to Next Section on Click
    /*****************************************************/
    $(".scroll-to-next-section").on("click", function (e) {
      e.preventDefault();
      const nextSection = $("#MainContent section").next();
      console.log("nextSection", nextSection);

      if (nextSection.length > 0) {
        $("html, body").animate({ scrollTop: $(nextSection).offset().top }, 600);
      }
    });

    /***************************************************
      Data Attribute Scroll to Next Section
    /*****************************************************/
    $(document).on("click", "[data-scroll-next-section]", function (e) {
      e.preventDefault();

      // Find the current section that contains this element
      const currentSection = $(this).closest("section");

      if (currentSection.length > 0) {
        // Find the next section after the current one
        const nextSection = currentSection.next("section");

        if (nextSection.length > 0) {
          $("html, body").animate({ scrollTop: nextSection.offset().top }, 600);
        }
      }
    });

    /***************************************************
      Stat Counter Handlers
    /*****************************************************/
    if ($(".stats-section").length) {
      gsap.utils.toArray(".counter-value").forEach((el) => {
        gsap.from(el, {
          scrollTrigger: {
            trigger: el,
            start: "top 85%",
            end: "bottom top",
            once: true,
            onEnter: () => {
              $(el)
                .prop("Counter", 0)
                .animate(
                  { Counter: $(el).attr("data-count") },
                  {
                    duration: 2000,
                    easing: "linear",
                    step: function (now) {
                      $(el).text(Math.floor(now));
                    },
                    complete: function () {
                      $(el).text(this.Counter);
                    },
                  }
                );
            },
          },
        });
      });
    }

    /***************************************************
      Footer Image Animation
    /*****************************************************/
    if ($("footer .footer-images").length) {
      // gsap.utils.toArray("footer .footer-top").forEach((el) => {
      //   gsap.from(el, {
      //     scrollTrigger: {
      //       trigger: el,
      //       start: "center bottom",
      //       end: "bottom top",
      //       // markers: true,
      //       onEnter: () => {
      //         $(el).addClass("show");
      //       },
      //     },
      //   });
      // });
    }

    /***************************************************
     * Mailchimp Shadow DOM Style Injection
     * This injects custom styles into the shadow root
    /*****************************************************/
    function injectMailchimpShadowStyles() {
      const wrapper = document.querySelector(".mcforms-wrapper");
      if (!wrapper) return;

      // Find the shadow root (may be nested in a child element)
      const findShadowRoot = (element) => {
        if (element.shadowRoot) return element.shadowRoot;
        for (const child of element.children) {
          const shadow = findShadowRoot(child);
          if (shadow) return shadow;
        }
        return null;
      };

      const shadowRoot = findShadowRoot(wrapper);
      if (!shadowRoot) {
        // Shadow root not yet attached, retry after a delay
        setTimeout(injectMailchimpShadowStyles, 500);
        return;
      }

      // Check if styles already injected
      if (shadowRoot.querySelector("#custom-mc-styles")) return;

      // Create and inject custom styles
      const styleEl = document.createElement("style");
      styleEl.id = "custom-mc-styles";
      styleEl.textContent = `
        /* Mailchimp button positioning */
        #el_1Iv_niHEIt {
          /* Adjust these values as needed */
         top: auto !important;
         left: 0.5rem !important;
         bottom: 6rem !important;
         right: auto !important;
        }
      `;
      shadowRoot.prepend(styleEl);
    }

    // Run on load and observe for dynamically added elements
    injectMailchimpShadowStyles();

    // Also observe for dynamic insertion of Mailchimp widget
    const mcObserver = new MutationObserver(function (mutations) {
      if (document.querySelector(".mcforms-wrapper")) {
        injectMailchimpShadowStyles();
      }
    });
    mcObserver.observe(document.body, { childList: true, subtree: true });
  });
})(jQuery);
